export const MOBILE_HEADER_OFFSET = 100
